export const SUPPORTED_LOCALES = ['ru', 'en', 'by', 'uk', 'es', 'de', 'fr', 'pt'] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_LABELS: Record<AppLocale, string> = {
  ru: 'Русский',
  en: 'English',
  by: 'Беларуская',
  uk: 'Українська',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  pt: 'Português',
};

export const LOCALE_SHORT_LABELS: Record<AppLocale, string> = {
  ru: 'RU',
  en: 'EN',
  by: 'BY',
  uk: 'UK',
  es: 'ES',
  de: 'DE',
  fr: 'FR',
  pt: 'PT',
};

const LOCALE_ALIASES: Record<string, AppLocale> = {
  ru: 'ru',
  en: 'en',
  'en-us': 'en',
  'en-gb': 'en',
  es: 'es',
  de: 'de',
  fr: 'fr',
  pt: 'pt',
  'pt-br': 'pt',
  uk: 'uk',
  ua: 'uk',
  by: 'by',
  // Browser / BCP-47 codes for Belarusian language → app locale `by`
  be: 'by',
  'be-by': 'by',
};

export const resolveAppLocale = (value: string | null | undefined): AppLocale => {
  if (!value) {
    return 'ru';
  }
  const normalized = value.trim().toLowerCase().replace(/_/g, '-');
  return LOCALE_ALIASES[normalized] ?? 'ru';
};

export const isSupportedLocale = (value: string): value is AppLocale =>
  (SUPPORTED_LOCALES as readonly string[]).includes(value);

export const BILINGUAL_LANGUAGE_LABEL = 'Язык • Language';

/** Login page: bilingual label for Russian or undetectable browser language. */
export const shouldUseBilingualLanguageLabelOnLogin = (): boolean => {
  if (typeof navigator === 'undefined') {
    return true;
  }

  const raw = navigator.language?.trim();
  if (!raw) {
    return true;
  }

  const normalized = raw.toLowerCase().replace(/_/g, '-');
  if (normalized.startsWith('ru')) {
    return true;
  }

  return resolveAppLocale(raw) === 'ru';
};
